var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_142_638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00169 0C8.95103 0.0262077 11.47 2.13082 11.9386 4.9568C12.1149 6.02154 11.8944 7.01388 11.4836 7.98623C10.8424 9.50316 9.99532 10.9117 9.04621 12.259C8.21688 13.4361 7.34019 14.5812 6.47716 15.7353C6.21984 16.0795 5.81725 16.0875 5.5572 15.7624C3.99782 13.8128 2.53317 11.8006 1.32539 9.62088C0.833527 8.73337 0.393586 7.82276 0.141736 6.83842C-0.149736 5.69906 0.0278795 4.597 0.509264 3.5487C1.35271 1.71149 2.80643 0.577457 4.82214 0.146141C5.20789 0.0635203 5.6082 0.0470849 6.00215 0H6.00169ZM6.00033 14.591C6.05042 14.5319 6.08868 14.4928 6.1201 14.4489C6.97084 13.2589 7.84207 12.0817 8.66456 10.8731C9.37412 9.83009 10.0026 8.73781 10.4849 7.57268C10.7718 6.87929 10.9727 6.17657 10.8939 5.40899C10.6534 3.06185 8.66365 1.17401 6.25263 1.10294C4.1472 1.04076 2.57325 1.95225 1.60456 3.7779C1.06443 4.79645 0.906395 5.88784 1.31628 6.99567C1.53534 7.58734 1.7881 8.17146 2.08003 8.73248C2.99998 10.5008 4.14401 12.1333 5.33996 13.7319C5.5531 14.0167 5.77352 14.2965 6.00033 14.5914V14.591Z",
    fill: "#2356c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72724 5.86663C8.7223 7.34764 7.49758 8.5392 5.98555 8.53326C4.47771 8.5277 3.26854 7.32649 3.27272 5.83843C3.27689 4.37931 4.51756 3.19183 6.02882 3.19999C7.51428 3.20816 8.73179 4.41122 8.72724 5.86663ZM4.18168 5.86626C4.18016 6.8437 4.99348 7.64154 5.99542 7.64525C6.99357 7.64896 7.81714 6.84927 7.8179 5.87479C7.81866 4.89215 7.00761 4.0906 6.01098 4.08912C4.99955 4.08763 4.18319 4.88065 4.18168 5.86626Z",
    fill: "#2356c0",
    stroke: "#2356c0",
    strokeWidth: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_142_638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.82c562d9427bb9624d62edef475b7fba.svg";
export { ForwardRef as ReactComponent };